export const StatusEnum = {
  NEEDS_REVIEW: {
    id: 1,
    statusIcon: "/images/statusIcons/needs-review.svg",
  },
  PROCESSING: {
    id: 2,
    statusIcon: "/images/statusIcons/processing-request.svg",
  },
  AWAITING_PUBLISH: {
    id: 3,
    statusIcon: "",
  },
  PUBLISHED: {
    id: 4,
    statusIcon: "",
  },
  DELETED: {
    id: 5,
    statusIcon: "",
  },
};

export const retrieveStatusIconImg = (status) => {
  const statusEnumKeys = Object.keys(StatusEnum);
  let iconImg = StatusEnum.NEEDS_REVIEW.statusIcon;
  statusEnumKeys.forEach((element) => {
    if (StatusEnum[element].id === status) {
      iconImg = StatusEnum[element].statusIcon;
    }
  });

  return iconImg;
};
